import {
	Backdrop,
	Box,
	Button,
	Card,
	Chip,
	CircularProgress,
	Divider,
	IconButton,
	TextField,
	Typography,
	useMediaQuery,
} from '@mui/material'
import React, { Fragment, useCallback, useEffect, useState } from 'react'
import UserLayout from '../../layouts/UserLayout'
import AutorenewOutlinedIcon from '@mui/icons-material/AutorenewOutlined'
import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getFromStorage } from '../../utils/storage'
import { DOMAIN } from '../../utils/api'
import axios from 'axios'
import { handleError } from '../../utils/error'
import { currentUserActions } from '../../redux/store'
import WbSunnyIcon from '@mui/icons-material/WbSunny'
import DarkModeIcon from '@mui/icons-material/DarkMode'
import PickDateWithoutShiftGrow from '../../components/PickDateWithoutShiftGrow'
import AddPhotoAlternateRoundedIcon from '@mui/icons-material/AddPhotoAlternateRounded'
import { mainGreen, mainRed } from '../../utils/color'
import { getTextOfInternalSale } from '../../utils/helper'

export default function ProductStockMultiPic() {
	const location = useLocation()
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const mediaMd = useMediaQuery('(min-width:768px)')
	const { currentUser } = useSelector((state) => state.currentUser)
	const token = getFromStorage('current-user')?.accessToken
	const [showReImportBackdrop, setShowReImportBackdrop] = useState(false)
	const [showGrillBackdrop, setShowGrillBackdrop] = useState(false)
	const [showEditCheckStockBackdrop, setShowEditCheckStockBackdrop] = useState(false)
	const [currentGrill, setCurrentGrill] = useState()
	const [showCheckStockBackdrop, setShowCheckStockBackdrop] = useState(false)
	const [loadingCheckStock, setLoadingCheckStock] = useState(false)
	const [loadingGrill, setLoadingGrill] = useState(false)
	const [loadingReImportFresh, setLoadingReImportFresh] = useState(false)
	const [isViewerOpen, setIsViewerOpen] = useState(false)
	const [currentImage, setCurrentImage] = useState(null)
	const [editCheckStock, setEditCheckStock] = useState('')

	const [subStock, setSubStock] = useState({
		freshInventory: '',
		cookedInventory: '',
	})
	const [history, setHistory] = useState([])
	const [historyByTime, setHistoryByTime] = useState([])
	const [shift, setShift] = useState({ morning: true, afternoon: false })
	const today = new Date()
	const [timePick, setTimePick] = useState({
		date: today.getDate()?.toString(),
		month: (today.getMonth() + 1)?.toString(),
		year: today.getFullYear()?.toString(),
	})
	const [cookedQuantity, setCookedQuantity] = useState('')
	const [reImportFreshReason, setReImportFreshReason] = useState('')
	const [checkStock, setCheckStock] = useState('')
	const [checkProductStockStatus, setCheckProductStockStatus] = useState()
	const [fileUpload, setFileUpload] = useState([])

	const [disabled, setDisabled] = useState(false)
	const [preview, setPreview] = useState([])

	useEffect(() => {
		if (!fileUpload) {
			setPreview(undefined)
			return
		}
		let preview = []
		for (let i = 0; i < fileUpload.length; i++) {
			preview.push(URL.createObjectURL(fileUpload[i]))
		}
		setPreview(preview)
	}, [fileUpload])

	const openImageViewer = (photo) => {
		setCurrentImage(photo)
		setIsViewerOpen(true)
	}

	const closeImageViewer = () => {
		setCurrentImage(null)
		setIsViewerOpen(false)
	}

	const onFileChange = async (e) => {
		setFileUpload(e.target.files)
	}

	const checkStockSubmit = async function (e) {
		e.preventDefault()
		if (checkStock.trim() === '') {
			alert('Khối lượng không được để trống!')
			return
		}
		if (+checkStock < 0) {
			alert('Tồn kho không bé hơn 0!')
			return
		}

		setLoadingCheckStock(true)
		try {
			const formData = new FormData()
			formData.append('quantity', checkStock)
			for (let i = 0; i < fileUpload.length; i++) {
				formData.append('image', fileUpload[i])
			}
			const res = await axios({
				method: 'POST',
				url: `${DOMAIN}/sub-stock/check-product/${currentUser.store}`,
				data: formData,

				headers: {
					Authorization: `Bearer ${token}`,
					'Content-Type': 'multipart/form-data',
				},
			})
			if (res.data.message) {
				alert(res.data.message)
			}
			setFileUpload([])
			setShowCheckStockBackdrop(false)
			setLoadingCheckStock(false)
			getCheckProductStockStatus()
		} catch (err) {
			handleError(err)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}

	const handleChangeCooked = (e) => {
		setCookedQuantity(e.target.value)
	}

	const handleChangeCheckStock = (e) => {
		setCheckStock(e.target.value)
	}

	const handleChangeEditCheckStock = (e) => {
		setEditCheckStock(e.target.value)
	}

	const handleChangeReImportFresh = (e) => {
		setReImportFreshReason(e.target.value)
	}

	const setTime = (time) => {
		setTimePick(time)
	}

	const getCheckProductStockStatus = useCallback(
		async function () {
			try {
				const response = await axios({
					url: `${DOMAIN}/sub-stock/check-product-stock/${currentUser.store}`,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					method: 'GET',
				})
				setCheckProductStockStatus(response.data)
			} catch (error) {
				console.log(error.response.data.message)
			}
		},
		[token, currentUser.store],
	)

	useEffect(() => {
		getCheckProductStockStatus()
	}, [getCheckProductStockStatus])

	const editCheckStockSubmit = async function (e, id) {
		e.preventDefault()
		if (editCheckStock.trim() === '') {
			alert('Khối lượng không được để trống!')
			return
		}
		if (+editCheckStock < 0) {
			alert('Tồn kho không bé hơn 0!')
		}
		setDisabled(true)
		try {
			await axios({
				method: 'PUT',
				url: `${DOMAIN}/sub-stock/edit-check-product`,
				data: { editCheckStock, id },

				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
			setShowEditCheckStockBackdrop(false)
			setDisabled(false)
			setEditCheckStock('')
			getCheckProductStockStatus()
		} catch (err) {
			handleError(err)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}

	const cancelCheckProductStock = async () => {
		try {
			await axios({
				url: `${DOMAIN}/sub-stock/cancel-check-product-stock/${currentUser.store}`,
				method: 'PUT',
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
			await getCheckProductStockStatus()
		} catch (err) {
			handleError(err)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}

	const getHistory = useCallback(
		async function () {
			try {
				const response = await axios({
					url: `${DOMAIN}/sub-stock/all-history/${currentUser.store}`,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					method: 'GET',
				})
				setHistory(response.data)
			} catch (error) {
				console.log(error.response.data.message)
			}
		},
		[token, currentUser.store],
	)

	useEffect(() => {
		getHistory()
	}, [getHistory])

	const getHistoryByTime = useCallback(
		async function () {
			const { date, month, year } = timePick
			try {
				const response = await axios({
					url: `${DOMAIN}/sub-stock/product-history/${currentUser.store}?shift=${shift.morning}&date=${date}&month=${month}&year=${year}`,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					method: 'GET',
				})
				setHistoryByTime(response.data)
			} catch (error) {
				console.log(error.response.data.message)
			}
		},
		[token, timePick, shift.morning, currentUser.store],
	)

	useEffect(() => {
		getHistoryByTime()
	}, [getHistoryByTime])

	const getSubStock = useCallback(
		async function () {
			try {
				const response = await axios({
					url: `${DOMAIN}/sub-stock/${currentUser.store}`,
					method: 'GET',
					headers: {
						Authorization: `Bearer ${token}`,
					},
				})
				setSubStock(response.data[0])
			} catch (err) {
				handleError(err)
				dispatch(currentUserActions.isLogout())
				navigate('/login')
			}
		},
		[dispatch, navigate, token, currentUser.store],
	)

	useEffect(() => {
		getSubStock()
	}, [getSubStock])

	const refresh = function () {
		getSubStock()
		getHistory()
		getHistoryByTime()
		getCheckProductStockStatus()
	}

	const reImportFresh = async (e, action, quantity, id) => {
		e.preventDefault()

		if (reImportFreshReason.trim() === '') {
			alert('Điền lý do tái nhập')
			return
		}
		setReImportFreshReason('')
		try {
			setDisabled(true)
			setLoadingReImportFresh(true)
			const formData = new FormData()
			formData.append('quantity', quantity)
			formData.append('id', id)
			formData.append('reImportReason', reImportFreshReason)
			for (let i = 0; i < fileUpload.length; i++) {
				formData.append('image', fileUpload[i])
			}
			const response = await axios({
				url: `${DOMAIN}/sub-stock/${action}/${currentUser.store}`,
				method: 'PUT',
				headers: {
					Authorization: `Bearer ${token}`,
					'Content-Type': 'multipart/form-data',
				},
				data: formData,
			})
			if (response.data.message) {
				alert(response.data.message)
			}
			await getSubStock()
			await getHistory()
			await getHistoryByTime()
			setShowReImportBackdrop(false)
			setDisabled(false)
			setLoadingReImportFresh(false)
		} catch (err) {
			handleError(err)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}

	const grill = async (e, action, id, quantity) => {
		e.preventDefault()

		if (cookedQuantity.trim() === '') {
			alert('Điền khối lượng nướng')
			return
		}

		if (+cookedQuantity > quantity) {
			alert('Khối lượng không hợp lệ!')
			return
		}

		if (+cookedQuantity < 0) {
			alert('Khối lượng phải lớn hơn 0!')
			return
		}
		setCookedQuantity('')
		try {
			setLoadingGrill(true)
			const response = await axios({
				url: `${DOMAIN}/sub-stock/${action}/${currentUser.store}`,
				method: 'PUT',
				headers: {
					Authorization: `Bearer ${token}`,
				},
				data: {
					id,
					cookedQuantity,
				},
			})
			if (response.data.message) {
				alert(response.data.message)
			}
			await getSubStock()
			await getHistory()
			await getHistoryByTime()
			setShowGrillBackdrop(false)
			setLoadingGrill(false)
		} catch (err) {
			handleError(err)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}

	return (
		<UserLayout>
			<Box
				sx={{
					maxWidth: 992,
					margin: '0 auto',
				}}>
				<Backdrop
					sx={{
						color: '#fff',
						zIndex: 999,
						left: mediaMd ? 300 : 0,
					}}
					open={isViewerOpen}
					onClick={closeImageViewer}>
					<img
						loading='lazy'
						src={currentImage}
						alt='attach'
						style={{
							maxHeight: '70%',
							maxWidth: '90%',
						}}
						onClick={(e) => {
							e.stopPropagation()
						}}
					/>
				</Backdrop>
				<Box sx={{ display: 'flex' }}>
					<h3
						style={{
							margin: 0,
							padding: '10px',
							textAlign: 'center',
							background: location.pathname === '/store-manager/stock/fresh' ? mainGreen : 'rgba(0, 0, 0, 0.08)',
							color: location.pathname === '/store-manager/stock/fresh' ? '#fff' : '#000',
							cursor: 'pointer',
							width: '50%',
						}}
						onClick={() => {
							navigate('/store-manager/stock/fresh')
						}}>
						KHO SỐNG
					</h3>
					<h3
						style={{
							margin: 0,
							padding: '10px',
							textAlign: 'center',
							background: location.pathname === '/store-manager/stock/product' ? mainGreen : 'rgba(0, 0, 0, 0.08)',
							color: location.pathname === '/store-manager/stock/product' ? '#fff' : '#000',
							cursor: 'pointer',
							width: '50%',
						}}
						onClick={() => {
							navigate('/store-manager/stock/product')
						}}>
						KHO CHÍN
					</h3>
				</Box>
				<Card
					sx={{
						mb: 2,
						padding: '10px',
					}}>
					<Box display='flex' justifyContent='space-between'>
						<Button
							sx={{
								textTransform: 'none',
								padding: '3px',
								color: mainGreen,
								borderColor: mainGreen,
								'&:hover': {
									borderColor: mainGreen,
								},
							}}
							variant='outlined'
							size='small'
							onClick={refresh}>
							<AutorenewOutlinedIcon sx={{ fontSize: '16px' }} />
							Cập nhật
						</Button>
					</Box>
					<Box
						sx={{
							mt: 2,
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
						}}>
						<h3 style={{ margin: 0, textAlign: 'center' }}>TỒN CHÍN</h3>
						<Box
							sx={{
								background: '#637381',
								padding: '5px 10px',
								borderRadius: '5px',
							}}>
							<Typography
								sx={{
									color: '#fff',
								}}>
								<b>
									{String(subStock?.cookedInventory) !== ''
										? Number(subStock?.cookedInventory)?.toFixed(1)
										: subStock?.cookedInventory}{' '}
									kg
								</b>
							</Typography>
						</Box>
					</Box>
					<Divider sx={{ mt: 2, mb: 2 }} />
					<Button
						size='small'
						variant='outlined'
						sx={{
							mb: 1,
							color: mainRed,
							borderColor: mainRed,
							'&:hover': {
								borderColor: mainRed,
							},
						}}
						onClick={async () => {
							if (
								history?.filter(
									(item) =>
										(item.action === 'freshExport' && !item.reImportFresh && !item.cooked) ||
										item.action === 'confirmReImportFresh',
								).length === 0
							) {
								setShowCheckStockBackdrop(true)
							} else {
								alert('Chưa hoàn tất nướng hoặc tái nhập sống!')
							}
						}}>
						Kiểm kho chín
					</Button>
					<Divider sx={{ mt: 1, mb: 1 }} />
					<Typography>
						<b>Kiểm kho:</b>{' '}
						<span>
							{checkProductStockStatus ? <span style={{ color: mainRed }}>đang chờ duyệt</span> : 'chưa có dữ liệu'}
						</span>
					</Typography>
					{checkProductStockStatus && (
						<>
							<b>{checkProductStockStatus?.user.name}</b> đang kiểm kho chín. Tồn thực tế{' '}
							<b>{checkProductStockStatus?.quantity?.toFixed(1)}</b> kg. Tồn hệ thống{' '}
							<b>{checkProductStockStatus?.checkStockSystem?.toFixed(1)}</b> kg. Chênh lệch:{' '}
							{checkProductStockStatus?.quantity - checkProductStockStatus?.checkStockSystem > 0 ? (
								<b>+{(checkProductStockStatus?.quantity - checkProductStockStatus?.checkStockSystem).toFixed(1)} </b>
							) : (
								<b>{(checkProductStockStatus?.quantity - checkProductStockStatus?.checkStockSystem).toFixed(1)} </b>
							)}
							kg
							<Box sx={{ mt: 2 }}>
								<Button
									size='small'
									variant='outlined'
									sx={{
										mr: 1,
										mb: 1,
										color: mainGreen,
										borderColor: mainGreen,
										'&:hover': {
											borderColor: mainGreen,
										},
									}}
									onClick={() => {
										setShowEditCheckStockBackdrop(true)
									}}>
									Chỉnh sửa
								</Button>
								<Button
									size='small'
									variant='outlined'
									sx={{
										mr: 1,
										mb: 1,
										color: mainRed,
										borderColor: mainRed,
										'&:hover': {
											borderColor: mainRed,
										},
									}}
									onClick={() => {
										cancelCheckProductStock()
									}}>
									Hủy kiểm kho
								</Button>
							</Box>
						</>
					)}
					<Backdrop
						sx={{
							color: '#fff',
							zIndex: (theme) => theme.zIndex.drawer + 1,
							left: mediaMd ? 300 : 0,
						}}
						open={showEditCheckStockBackdrop}>
						<Card
							sx={{ padding: '10px 20px', width: '280px' }}
							onClick={(e) => {
								e.stopPropagation()
							}}>
							<Typography
								sx={{
									textAlign: 'center',
									fontSize: '18px',
									fontWeight: 'bold',
									mb: 1,
								}}>
								Tồn kho sống thực tế
							</Typography>
							<TextField
								fullWidth
								type='number'
								label='kg'
								value={editCheckStock}
								onChange={handleChangeEditCheckStock}
							/>
							<Box display='flex' justifyContent='space-between'>
								<Button
									disabled={disabled}
									sx={{
										mt: 2,
										width: '75%',
										mr: 1,
										background: mainGreen,
										'&:hover': { background: mainGreen },
									}}
									size='small'
									variant='contained'
									onClick={(e) => {
										editCheckStockSubmit(e, checkProductStockStatus._id)
									}}>
									Xác nhận
								</Button>
								<Button
									sx={{
										mt: 2,
										background: mainRed,
										'&:hover': { background: mainRed },
									}}
									variant='contained'
									size='small'
									onClick={() => {
										setShowEditCheckStockBackdrop(false)
										setEditCheckStock('')
									}}>
									Hủy
								</Button>
							</Box>
						</Card>
					</Backdrop>
					<Backdrop
						sx={{
							color: '#fff',
							zIndex: (theme) => theme.zIndex.drawer + 1,
							left: mediaMd ? 300 : 0,
						}}
						open={showCheckStockBackdrop}>
						<Card
							sx={{ padding: '10px 20px', width: '280px' }}
							onClick={(e) => {
								e.stopPropagation()
							}}>
							<Typography
								sx={{
									textAlign: 'center',
									fontSize: '18px',
									fontWeight: 'bold',
									mb: 1,
								}}>
								Tồn kho chín
							</Typography>
							{loadingCheckStock && (
								<Box sx={{ textAlign: 'center', mt: 2 }}>
									<CircularProgress sx={{ color: mainGreen }} />
								</Box>
							)}
							{!loadingCheckStock && (
								<>
									<TextField
										fullWidth
										type='number'
										label='KL thực tế (kg)'
										value={checkStock}
										onChange={handleChangeCheckStock}
									/>
									<Box sx={{ mt: 2 }}>
										{fileUpload &&
											preview?.map((preview, index) => {
												return (
													<img
														loading='lazy'
														key={index}
														style={{
															width: 50,
															marginRight: '8px',
														}}
														src={preview}
														alt='preview'
													/>
												)
											})}
										<Box>
											<IconButton sx={{ padding: '0' }}>
												<label htmlFor='choose-photo-check-product' style={{ display: 'flex', cursor: 'pointer' }}>
													<AddPhotoAlternateRoundedIcon sx={{ color: mainGreen }} />
												</label>
											</IconButton>
											<input
												multiple
												accept='image/*'
												onChange={onFileChange}
												id='choose-photo-check-product'
												type='file'
												style={{ display: 'none' }}
											/>
										</Box>
									</Box>
									<Box display='flex' justifyContent='space-between'>
										<Button
											sx={{
												mt: 2,
												width: '75%',
												mr: 1,
												background: mainGreen,
												'&:hover': { background: mainGreen },
											}}
											size='small'
											variant='contained'
											onClick={(e) => {
												checkStockSubmit(e)
											}}>
											Xác nhận
										</Button>
										<Button
											sx={{
												mt: 2,
												background: mainRed,
												'&:hover': { background: mainRed },
											}}
											variant='contained'
											size='small'
											onClick={() => {
												setShowCheckStockBackdrop(false)
												setFileUpload([])
												setCheckStock('')
											}}>
											Hủy
										</Button>
									</Box>
								</>
							)}
						</Card>
					</Backdrop>
				</Card>
				<Card sx={{ padding: '10px', mb: 2 }}>
					<Typography
						sx={{
							textAlign: 'center',
							fontSize: '18px',
							fontWeight: 'bold',
							mb: 1,
						}}>
						Bếp nướng
					</Typography>
					{history?.filter((item) => item.action === 'freshExport' && !item.reImportFresh && !item.cooked).length ===
						0 && <Typography sx={{ textAlign: 'center', fontStyle: 'italic', mt: 1 }}>(Chưa có dữ liệu)</Typography>}
					<Box sx={{ mt: 2 }}>
						{history
							?.filter((item) => item.action === 'freshExport' && !item.reImportFresh && !item.cooked)
							.map((item, index) => {
								return (
									<Fragment key={index}>
										<Box
											sx={{
												display: 'flex',
												justifyContent: 'space-between',
												alignItems: 'center',
												mt: 1,
											}}>
											<Box>
												<Typography sx={{ textAlign: 'left' }}>
													Nem sống: <b>{item?.remainingCookedQuantity?.toFixed(4)}kg</b>
												</Typography>
												<Typography
													style={{
														fontStyle: 'italic',
														fontSize: '12px',
														marginTop: '3px',
													}}>
													- {item?.timeStamp} -
												</Typography>
											</Box>
											<Box>
												<Button
													size='small'
													variant='contained'
													sx={{
														mr: 1,
														textTransform: 'none',
														padding: '3px 9px',
														mb: 1,
														background: mainRed,
														'&:hover': { background: mainRed },
													}}
													onClick={() => {
														setCurrentGrill(item._id)
														setShowGrillBackdrop(true)
													}}>
													Nướng
												</Button>
												<Backdrop
													sx={{
														color: '#fff',
														zIndex: (theme) => theme.zIndex.drawer + 1,
														left: mediaMd ? 300 : 0,
													}}
													open={showGrillBackdrop}>
													<Card
														sx={{ padding: '10px 20px', width: '280px' }}
														onClick={(e) => {
															e.stopPropagation()
														}}>
														<Typography
															sx={{
																textAlign: 'center',
																fontSize: '18px',
																fontWeight: 'bold',
																mb: 1,
															}}>
															Xử lý nướng
														</Typography>
														{loadingGrill && (
															<Box sx={{ textAlign: 'center', mt: 2 }}>
																<CircularProgress sx={{ color: mainGreen }} />
															</Box>
														)}
														{!loadingGrill && (
															<>
																<TextField
																	fullWidth
																	type='number'
																	label='KL nướng (kg)'
																	value={cookedQuantity}
																	onChange={handleChangeCooked}
																/>
																<Typography sx={{ mt: 2 }}>
																	<b>Thành phẩm:</b> {(cookedQuantity * (1 - subStock.lossRatio / 100)).toFixed(1)}
																	kg
																</Typography>
																<Box display='flex' justifyContent='space-between'>
																	<Button
																		sx={{
																			mt: 2,
																			width: '75%',
																			mr: 1,
																			background: mainGreen,
																			'&:hover': { background: mainGreen },
																		}}
																		size='small'
																		variant='contained'
																		onClick={async (e) => {
																			await grill(e, 'grill', currentGrill, item.quantity)
																		}}>
																		Xác nhận
																	</Button>
																	<Button
																		sx={{
																			mt: 2,
																			background: mainRed,
																			'&:hover': { background: mainRed },
																		}}
																		variant='contained'
																		size='small'
																		onClick={() => setShowGrillBackdrop(false)}>
																		Hủy
																	</Button>
																</Box>
															</>
														)}
													</Card>
												</Backdrop>
												<Button
													sx={{
														textTransform: 'none',
														padding: '3px 9px',
														mb: 1,
														background: mainGreen,
														'&:hover': { background: mainGreen },
													}}
													size='small'
													variant='contained'
													onClick={() => {
														setShowReImportBackdrop(true)
													}}>
													Tái nhập sống
												</Button>
												<Backdrop
													sx={{
														color: '#fff',
														zIndex: (theme) => theme.zIndex.drawer + 1,
														left: mediaMd ? 300 : 0,
													}}
													open={showReImportBackdrop}>
													<Card
														sx={{ padding: '10px 20px', width: '280px' }}
														onClick={(e) => {
															e.stopPropagation()
														}}>
														<Typography
															sx={{
																textAlign: 'center',
																fontSize: '18px',
																fontWeight: 'bold',
																mb: 1,
															}}>
															Lý do tái nhập
														</Typography>
														{loadingReImportFresh && (
															<Box sx={{ textAlign: 'center', mt: 2 }}>
																<CircularProgress sx={{ color: mainGreen }} />
															</Box>
														)}
														{!loadingReImportFresh && (
															<>
																<TextField
																	fullWidth
																	type='text'
																	value={reImportFreshReason}
																	onChange={handleChangeReImportFresh}
																/>
																<Box sx={{ mt: 2 }}>
																	{preview?.map((img, index) => {
																		return (
																			<img
																				loading='lazy'
																				key={index}
																				style={{
																					width: 50,
																					marginRight: '8px',
																				}}
																				src={img}
																				alt='preview'
																			/>
																		)
																	})}
																	<Box>
																		<IconButton sx={{ padding: '0' }}>
																			<label
																				htmlFor='choose-photo-reimport-fresh'
																				style={{
																					display: 'flex',
																					cursor: 'pointer',
																				}}>
																				<AddPhotoAlternateRoundedIcon sx={{ color: mainGreen }} />
																			</label>
																		</IconButton>
																		<input
																			multiple
																			accept='image/*'
																			onChange={onFileChange}
																			id='choose-photo-reimport-fresh'
																			type='file'
																			style={{ display: 'none' }}
																		/>
																	</Box>
																</Box>
																<Box display='flex' justifyContent='space-between'>
																	<Button
																		disabled={disabled}
																		sx={{
																			mt: 2,
																			width: '75%',
																			mr: 1,
																			background: mainGreen,
																			'&:hover': { background: mainGreen },
																		}}
																		size='small'
																		variant='contained'
																		onClick={(e) => {
																			reImportFresh(e, 're-import-fresh', item.remainingCookedQuantity, item._id)
																		}}>
																		Xác nhận
																	</Button>
																	<Button
																		sx={{
																			mt: 2,
																			background: mainRed,
																			'&:hover': { background: mainRed },
																		}}
																		variant='contained'
																		size='small'
																		onClick={() => {
																			setShowReImportBackdrop(false)
																			setFileUpload([])
																			setReImportFreshReason('')
																		}}>
																		Hủy
																	</Button>
																</Box>
															</>
														)}
													</Card>
												</Backdrop>
											</Box>
										</Box>

										<Divider />
									</Fragment>
								)
							})}
					</Box>
				</Card>

				<Card sx={{ padding: '10px', mb: 2 }}>
					<Typography
						sx={{
							textAlign: 'center',
							fontSize: '18px',
							fontWeight: 'bold',
							mb: 1,
						}}>
						Lịch sử xuất nhập
					</Typography>
					<PickDateWithoutShiftGrow time={timePick} setTime={setTime} />
					<Box display='flex' justifyContent='center'>
						<Chip
							onClick={() => {
								if (shift.morning === false) {
									setShift({ morning: true, afternoon: false })
								}
							}}
							size='small'
							sx={{
								cursor: 'pointer',
								mr: 4,
								background: shift.morning ? mainGreen : undefined,
								color: shift.morning ? '#fff' : '#000',
								'&:hover': {
									background: shift.morning ? mainGreen : undefined,
									color: shift.morning ? '#fff' : '#000',
								},
							}}
							label={
								<Typography
									sx={{
										fontSize: '14px',
										display: 'flex',
										justifyContent: 'center',
										alignItems: 'center',
										lineHeight: 1.3,
									}}>
									{' '}
									<WbSunnyIcon sx={{ mr: 1, fontSize: '20px' }} /> Sáng
								</Typography>
							}
						/>
						<Chip
							onClick={() => {
								if (shift.afternoon === false) {
									setShift({ morning: false, afternoon: true })
								}
							}}
							size='small'
							sx={{
								cursor: 'pointer',
								background: shift.afternoon ? mainGreen : undefined,
								color: shift.afternoon ? '#fff' : '#000',
								'&:hover': {
									background: shift.afternoon ? mainGreen : undefined,
									color: shift.afternoon ? '#fff' : '#000',
								},
							}}
							label={
								<Typography
									sx={{
										fontSize: '14px',
										display: 'flex',
										justifyContent: 'center',
										alignItems: 'center',
										lineHeight: 1.3,
									}}>
									{' '}
									<DarkModeIcon sx={{ mr: 1, fontSize: '20px' }} /> Chiều
								</Typography>
							}
						/>
					</Box>
					{historyByTime?.filter(
						(item) =>
							item.action !== 'checkProductStock' &&
							!(item.action === 'confirmCheckProductStock' && !item.checkStockRecord),
					)?.length === 0 && (
						<Typography sx={{ textAlign: 'center', fontStyle: 'italic', mt: 2 }}>(Chưa có dữ liệu)</Typography>
					)}
					<Box sx={{ mt: 2 }}>
						{historyByTime
							?.filter(
								(item) =>
									item.action !== 'checkProductStock' &&
									!(item.action === 'confirmCheckProductStock' && !item.checkStockRecord),
							)
							?.map((item, index) => {
								return (
									<Fragment key={index}>
										<Typography sx={{ textAlign: 'left', mt: 1 }}>
											{(item.action === 'soldProduct' || item.action === 'reImportCooked') && (
												<span>
													<b>
														{item?.shiftCode}
														{item?.shiftIndex}-{item?.shiftDay}.
													</b>{' '}
												</span>
											)}{' '}
											<b>{item.user?.name}</b>{' '}
											{item?.action === 'confirmCheckProductStock' && item?.checkStockRecord && (
												<>
													<span style={{ color: mainGreen }}>
														kiểm kho, tồn thực tế <b>{item?.quantity?.toFixed(1)}kg</b>
													</span>
													. Hệ thống{' '}
													<span style={{ color: mainGreen }}>
														<b>
															{item?.checkStockSystem?.toFixed(1)}
															kg.
														</b>
													</span>{' '}
													Chênh lệch:{' '}
													{item?.quantity - item?.checkStockSystem > 0 ? (
														<b>+{(item?.quantity - item?.checkStockSystem)?.toFixed(1)}</b>
													) : (
														<b>{(item?.quantity - item?.checkStockSystem)?.toFixed(1)}</b>
													)}
													kg. <b>{item?.confirmCheckStock?.user.name}</b> đã duyệt.
												</>
											)}
											{item.action === 'soldProduct' && (
												<span style={{ color: mainRed }}>
													xuất kho <b>{item?.quantity}kg.</b>
												</span>
											)}
											{item.action === 'cooked' && (
												<span>
													nướng <b>{item?.beforeCookedQuantity?.toFixed(1)}</b>
													kg sống ra <b>{item?.quantity.toFixed(1)}kg </b>chín.
												</span>
											)}
											{item.action === 'reImportCooked' && (
												<span style={{ color: mainGreen }}>
													hủy đơn tái nhập <b>{item?.quantity?.toFixed(1)}kg </b>nem. ({item?.deleteReason}).
												</span>
											)}{' '}
											{item?.action === 'crossStoreSell' || item?.action === 'crossStoreBuy'
												? getTextOfInternalSale(item, 'kg')
												: null}
											{(item?.cookedBalance || item?.cookedBalance === 0) && (
												<>
													Tồn{' '}
													<b>
														{item?.cookedBalance?.toFixed(1)}
														kg
													</b>
												</>
											)}
											{item?.reImportCookedReason && (
												<span
													style={{
														display: 'block',
														fontStyle: 'italic',
														margin: 0,
													}}>
													Lý do: {item?.reImportCookedReason}
												</span>
											)}
										</Typography>
										<Box display='flex' justifyContent='flex-end' alignItems='flex-end' sx={{ mb: 1 }}>
											{item?.deletePhoto && (
												<img
													loading='lazy'
													src={item?.deletePhoto}
													onClick={() => {
														openImageViewer(item?.deletePhoto)
													}}
													width='30'
													height='30'
													style={{
														marginRight: '8px',
														marginTop: '2px',
														cursor: 'pointer',
													}}
													alt=''
												/>
											)}
											{item?.deleteMultiPhoto?.map((img, index) => {
												return (
													<img
														loading='lazy'
														key={index}
														src={img}
														onClick={(e) => {
															openImageViewer(img)
														}}
														width='30'
														height='30'
														style={{
															marginRight: '8px',
															marginTop: '2px',
															cursor: 'pointer',
														}}
														alt=''
													/>
												)
											})}
											{item?.checkStockPicture && (
												<img
													loading='lazy'
													src={item?.checkStockPicture}
													onClick={() => {
														openImageViewer(item?.checkStockPicture)
													}}
													width='30'
													height='30'
													style={{
														marginRight: '8px',
														marginTop: '2px',
														cursor: 'pointer',
													}}
													alt=''
												/>
											)}
											{item?.checkStockMultiPicture?.map((img, index) => {
												return (
													<img
														loading='lazy'
														key={index}
														src={img}
														onClick={(e) => {
															openImageViewer(img)
														}}
														width='30'
														height='30'
														style={{
															marginRight: '8px',
															marginTop: '2px',
															cursor: 'pointer',
														}}
														alt=''
													/>
												)
											})}
											<Typography
												style={{
													fontStyle: 'italic',
													fontSize: '12px',
													textAlign: 'right',
												}}>
												- {item?.timeStamp} -{' '}
												{item?.confirmCheckStock && (
													<span style={{ color: mainRed }}>Duyệt: {item?.confirmCheckStock.timeStamp}</span>
												)}
											</Typography>{' '}
										</Box>

										<Divider />
									</Fragment>
								)
							})}
					</Box>
				</Card>
			</Box>
		</UserLayout>
	)
}
